import React, { useCallback, useState } from 'react';
import { Icon, Input } from 'semantic-ui-react';
import { css } from 'glamor';

const passwordToggleClass = css({
  pointerEvents: 'all !important',
  cursor: 'pointer !important',
});

export default function PasswordInput(props) {
  const [showPassword, setShowPassword] = useState(false);

  const toggleVisibility = useCallback(() => {
    setShowPassword(!showPassword);
  }, [showPassword]);

  const handleMouseDownPassword = useCallback((event) => {
    event.preventDefault();
  }, []);

  return (

    <Input
      {...props}
      type={showPassword ? 'text' : 'password'}
      autoComplete="off"
      icon={
        <Icon
          name={showPassword ? 'eye' : 'eye slash'}
          onClick={toggleVisibility}
          onMouseDown={handleMouseDownPassword}
          className={passwordToggleClass}
        />
      }
      iconPosition="right"
    />

  );
}
